"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserSessionState = exports.selectUserSessionJourneyStatus = exports.selectUserSession = exports.selectProcessFlowId = exports.selectMarketingId = exports.selectIsUserSessionLoaded = exports.selectIsSavingUserSession = void 0;
var _constants = require("../../utils/constants");
var _widgetSelectors = require("../widget/widgetSelectors");
var _shareRecommendationSelectors = require("../shareRecommendation/shareRecommendationSelectors");
var _recommendationSelectors = require("../recommendation/recommendationSelectors");
var _uiSelectors = require("../ui/uiSelectors");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var selectMarketingId = function selectMarketingId(state) {
  return state.drools.user.marketingId;
};
exports.selectMarketingId = selectMarketingId;
var selectProcessFlowId = function selectProcessFlowId(state) {
  var _state$drools$user$us;
  return (_state$drools$user$us = state.drools.user.userSession) === null || _state$drools$user$us === void 0 ? void 0 : _state$drools$user$us.id;
};
exports.selectProcessFlowId = selectProcessFlowId;
var selectIsUserSessionLoaded = function selectIsUserSessionLoaded(state) {
  return state.drools.user.isUserSessionLoaded;
};
exports.selectIsUserSessionLoaded = selectIsUserSessionLoaded;
var selectIsSavingUserSession = function selectIsSavingUserSession(state) {
  return state.drools.user.isSavingUserSession;
};
exports.selectIsSavingUserSession = selectIsSavingUserSession;
var selectUserSessionState = function selectUserSessionState(state, stateMetadata, questionIndex) {
  var questionnaire = state.drools.questionnaire;
  var settings = (0, _widgetSelectors.selectTransformedSettings)(state);
  var shareRecommendation = (0, _shareRecommendationSelectors.selectShareRecommendationData)(state);
  var selections = questionnaire.selections,
    answers = questionnaire.answers,
    questions = questionnaire.questions;
  var recommendationRawData = (0, _recommendationSelectors.selectRecommendationRawData)(state);
  var selectedHandsetId = (0, _recommendationSelectors.selectSelectedHandsetId)(state);
  var selectedPlanId = (0, _recommendationSelectors.selectSelectedPlanId)(state);
  var selectedBroadbandId = (0, _recommendationSelectors.selectSelectedBroadbandId)(state);
  var questionTitles = questions.map(function (question) {
    return question.title;
  });
  var timestamps = (0, _uiSelectors.selectTimestamps)(state);
  return {
    questionnaire: {
      currentQuestionIndex: questionIndex,
      selections: selections,
      answers: answers,
      questionTitles: questionTitles
    },
    recommendation: {
      recommendationRawData: recommendationRawData,
      selectedHandsetId: selectedHandsetId,
      selectedPlanId: selectedPlanId,
      selectedBroadbandId: selectedBroadbandId
    },
    stateMetadata: _objectSpread(_objectSpread({}, stateMetadata), {}, {
      settings: settings,
      shareRecommendation: shareRecommendation
    }),
    timestamps: timestamps
  };
};
exports.selectUserSessionState = selectUserSessionState;
var selectUserSession = function selectUserSession(state) {
  return state.drools.user.userSession;
};
exports.selectUserSession = selectUserSession;
var selectUserSessionJourneyStatus = function selectUserSessionJourneyStatus(state) {
  var _userSession$characte;
  var userSession = selectUserSession(state);
  if (!userSession) {
    return _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER;
  }
  var serializedSessionState = (_userSession$characte = userSession.characteristic.find(function (item) {
    return item.name === 'questionnaireState';
  })) === null || _userSession$characte === void 0 ? void 0 : _userSession$characte.value;
  if (!serializedSessionState || serializedSessionState === '{}') {
    return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_START;
  }
  var sessionState = JSON.parse(serializedSessionState);
  if (sessionState.questionnaire.currentQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
    return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_RECOMMENDATION;
  }
  return _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_QUESTIONNAIRE;
};
exports.selectUserSessionJourneyStatus = selectUserSessionJourneyStatus;